import { HistogramData } from "../../Model/HistogramData";
// import { Fov } from "../../Model/ModuleState";
import { ELiveImageAction, LiveImageAction } from "../actions/LiveImageAction";
import { RootState } from "./RootReducer";

type State = {
  showCrosshair: boolean;
  showRuler: boolean;
  showWellOverlay: boolean;
  // fov: Fov;
  histogramData: HistogramData;
  liveImageCropZoomX: number;
  liveImageCropZoomY: number;
};

const SHOW_CROSSHAIR = "SHOW_CROSSHAIR";
const SHOW_RULER = "SHOW_RULER";
const SHOW_WELL_OVERLAY = "SHOW_WELL_OVERLAY";

function getInitialState(): State {
  const showCrosshair = localStorage.getItem(SHOW_CROSSHAIR);
  const showRuler = localStorage.getItem(SHOW_RULER);
  const showWellOverlay = localStorage.getItem(SHOW_WELL_OVERLAY);

  const initialState: State = {
    liveImageCropZoomX: 1,
    liveImageCropZoomY: 1,
    showCrosshair:
      showCrosshair != null ? showCrosshair.toLowerCase() === "true" : false,
    showRuler: showRuler != null ? showRuler.toLowerCase() === "true" : true,
    showWellOverlay:  showWellOverlay != null ? showWellOverlay.toLowerCase() === "true" : false,
    // fov: {
    //   width: 0,
    //   height: 0,
    // },
    histogramData: {
      identifier: "",
      histogram: [],
    },
  };
  return initialState;
}

export function liveImageReducer(
  state = getInitialState(),
  action: LiveImageAction
): State {
  switch (action.type) {
    case ELiveImageAction.SET_LIVE_IMAGE_CROP_ZOOM:
      if (action.liveImageCropZoomX == null) {
        throw new Error("liveImageCropZoomX is null");
      }
      if (action.liveImageCropZoomY == null) {
        throw new Error("liveImageCropZoomY is null");
      }
      return {
        ...state,
        liveImageCropZoomX: action.liveImageCropZoomX,
        liveImageCropZoomY: action.liveImageCropZoomY,
      };
    case ELiveImageAction.SET_HISTOGRAM:
      if (action.histogramData == null) {
        throw new Error("Histogram data is null");
      }
      return {
        ...state,
        histogramData: action.histogramData,
      };
    case ELiveImageAction.SET_SHOW_CROSSHAIR:
      if (action.showCrosshair == null) {
        throw new Error("ShowCrosshair is null");
      }
      localStorage.setItem(SHOW_CROSSHAIR, action.showCrosshair.toString());
      return {
        ...state,
        showCrosshair: action.showCrosshair,
      };
    case ELiveImageAction.SET_SHOW_RULER:
      if (action.showRuler == null) {
        throw new Error("ShowRuler is null");
      }
      localStorage.setItem(SHOW_RULER, action.showRuler.toString());
      return {
        ...state,
        showRuler: action.showRuler,
      };

    case ELiveImageAction.SET_SHOW_WELL_OVERLAY:
      if (action.showWellOverlay == null) {
        throw new Error("ShowWellOverlay is null");
      }
      localStorage.setItem(SHOW_WELL_OVERLAY, action.showWellOverlay.toString());
      return {
        ...state,
        showWellOverlay: action.showWellOverlay,
      };

    // case ELiveImageAction.SET_FOV:
    //   if (action.fov == null) {
    //     throw new Error("Fov is null");
    //   }
    //   return {
    //     ...state,
    //     fov: action.fov,
    //   };
    default:
      return state;
  }
}

export const getHistogramData = (state: RootState): HistogramData =>
  state.liveImageStore.histogramData;
export const getShowCrossHair = (state: RootState): boolean =>
  state.liveImageStore.showCrosshair;
export const getShowRuler = (state: RootState): boolean =>
  state.liveImageStore.showRuler;
export const getShowWellOverlay = (state: RootState): boolean =>
  state.liveImageStore.showWellOverlay;
// export const getFov = (state: RootState): Fov => state.liveImageStore.fov;
